document.addEventListener("keydown", (e) => {
  if (e.key === "Enter" && e.target.classList.contains("x-disableEnter")) {
    e.preventDefault();
  }
});
